import Modules from '@/model/modules';
import {RouteModule} from '@/types/route-type';
import ReportList from './report-list/report-list';
import ReportRecent from './report-recent/report-recent';

const Module: RouteModule = {
    module: Modules.REPORT,
    pages: [
        {
            path: '/report',
            element: ReportList,
        },
        {
            path: '/report/recent',
            element: ReportRecent,
        },
    ],
};

export default Module;
